import {Component, Input} from '@angular/core';
import {Address} from '@spartacus/core/src/model/address.model';
import {DetailType} from '@app/model/order/dcp-order-entry.model';

@Component({
  selector: 'dcp-checkout-detail-section',
  templateUrl: './checkout-detail-section.component.html',
  styleUrls: ['./checkout-detail-section.component.scss']
})
export class CheckoutDetailSectionComponent {
  @Input() type: DetailType;
  @Input() title: string;
  @Input() explainText: string;
  @Input() address: Address;

  protected readonly DetailType = DetailType;
}
